if ($('body').hasClass('personalize-product-redesign')) {

    // Check if the first selector exists
    if ($('.product-info__block-item .tdf_discountable_product .tdf_price_sales .tdf_mn').length > 0) {
        salePrice = $('.product-info__block-item .tdf_discountable_product .tdf_price_sales .tdf_mn').text();
    } else {
        // Fallback to the alternative selector
        salePrice = $('.product-info .product-info__block-item .price-list sale-price .money').text();
    }

    // Update the price in the add-to-cart price display
    $('.addtocart-price-show').text(salePrice);

    // for main image change 
    $('.personalize_image_span,.product-gallery .page-dots,.personalize_all').css('display', 'block');
    $('.mobile-none-view').css('display', 'block').addClass('activeview');
    $('.product-gallery__image-list .contents,.product-gallery__thumbnail-list,.product-gallery .page-dots').css('display', 'none');

    // add attribute
    $('.stepsinput').attr('name', 'properties[Text]');
    $('.line-item-property__field .color-option:first-child').trigger("click");

    var selectedColor = $('.orangeradiobutton').val()
    $('.image_text_sp').css('color', selectedColor);

    $('.personalisation_cart,.per_addtocart .btn-new-addtocart').css({
        'pointer-events': 'none',
        'opacity': '0.6'
    });

    $('.stepsinput').on('keyup', function() {
        var inputText = $(this).val();

        if (inputText) {
            $('.stepsspan').text(inputText);
            $('.previewspan').css('display', 'block');
            $('.spnclassic').css('border-bottom', '1px solid #ddd');

            $('.personalisation_cart,.per_addtocart .btn-new-addtocart').css({
                'pointer-events': 'auto',
                'opacity': '1'
            });
        } else {
            $('.stepsspan').text('');
            $('.previewspan').css('display', 'none');
            $('.spnclassic').css('border-bottom', '0px solid #ddd');

            $('.personalisation_cart,.per_addtocart .btn-new-addtocart').css({
                'pointer-events': 'none',
                'opacity': '0.6'
            });
        }
    });

    $('.orangeradiobutton').on('click', function() {
        var selectedColor = $(this).val();
        $('.image_text_sp').css('color', selectedColor);
    });

  $(".personalisation_cart").click(function() {
    $(".buy-buttons button").trigger("click");

    setTimeout(function() {
        $(".modalspecial .close").trigger("click");
    }, 2000);
});
}
